import { useState } from "react"
import { getRank } from "../../api/api"

export default function RankTracker() {
  const [domain, setDomain] = useState("")
  const [keyword, setKeyword] = useState("")
  const [rank, setRank] = useState(null)

  async function load() {
    const res = await getRank(domain, keyword)
    setRank(res.data)
  }

  return (
    <div className="page">
      <h1>Rank Tracker</h1>
      <div className="card form-row">
        <label>
          Domain
          <input value={domain} onChange={(e) => setDomain(e.target.value)} placeholder="example.com" />
        </label>
        <label>
          Keyword
          <input value={keyword} onChange={(e) => setKeyword(e.target.value)} placeholder="seo tool" />
        </label>
        <button onClick={load}>Check rank</button>
      </div>
      {rank && (
        <div className="card">
          <p>
            <strong>{rank.keyword || keyword}</strong> for <strong>{rank.domain || domain}</strong>
          </p>
          <p>Position: {rank.position || "Not available"}</p>
          <p className="muted">{rank.message}</p>
        </div>
      )}
    </div>
  )
}
